







import TabItem from './tab-item.vue';
import { computed, defineComponent } from '@vue/composition-api';
import { useRoute } from '@/hooks/use-route';
import { biClick } from '@tencent/fit-bi-sdk';

export default defineComponent({
  name: 'MyCouponTap',
  components: {
    TabItem,
  },
  props: {
    num: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  setup(props) {
    const { router } = useRoute();
    const biExt = computed(() => ({
      fcount: `${props.num}`,
    }));
    return {
      biExt,
      clickTab() {
        router.push({
          name: 'couponlist',
        });
        biClick('my-coupon-tab.click|我的优惠券点击', biExt.value);
      },
    };
  },
});
